// Basic
import PropTypes from 'prop-types';
// Components
import HeaderTitle from '../headers/HeaderTitle/HeaderTitle';
import BodyConfirm from '../bodies/BodyConfirm/BodyConfirm';
import FooterConfirmation from '../footers/FooterConfirmation/FooterConfirmation';
import { Modal, ModalBody, ModalContent } from '../../../../ui/modal';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.confirmChoice
 * @param root0.isLoading
 * @param root0.entityTitle
 * @param root0.entityBody
 * @param root0.namespace
 * @returns {JSX.Element} ModalAskConfirmation Component
 */
function ModalAskConfirmation({ isOpen, setIsOpen, confirmChoice, isLoading, entityTitle, entityBody, namespace }) {
    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-lg'>
                <HeaderTitle namespace={namespace} title={entityTitle || 'Confirmation'} />
                <ModalBody>
                    <BodyConfirm namespace={namespace} confirmationMessage={entityBody || 'Voulez vous confirmer cette action?'} />
                </ModalBody>
                <FooterConfirmation onValidation={confirmChoice} isSubmitDisabled={isLoading} />
            </ModalContent>
        </Modal>
    );
}

ModalAskConfirmation.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    isLoading: PropTypes.bool,
    entityTitle: PropTypes.string,
    entityBody: PropTypes.string,
    namespace: PropTypes.string,
    confirmChoice: PropTypes.func
};
export default ModalAskConfirmation;